import { DashMessage } from "./DashMessage"
import { useDashboardDomainContext } from "../../../DashboardDomainProvider";
import { useCorePermissions } from "spark-core-dx/hooks";

export const NoVisualsMessage = () => {

    const { switchMode } = useDashboardDomainContext();
    const { canEdit } = useCorePermissions();

    return (
        <DashMessage
            icon={"edit"}
            title={"No Visuals Found!"}
            description={canEdit("Dashboard") ? "Add visuals to this published dashboard." : "Please contact your system adminstrator."}
            buttonText={canEdit("Dashboard") ? "Add Visuals" : null}
            onClick={() => switchMode("design")}
        />
    )
}